import React, { FC } from "react";

import ScheduleEdit from "../../components/Schedule/ScheduleEdit";

const ScheduleEditPage: FC = () => <ScheduleEdit />;

export default ScheduleEditPage;
